// extracted by mini-css-extract-plugin
export default {"produtos":"NossosProdutos_produtos__uwwRJ","tituloProd":"NossosProdutos_tituloProd__1e3Eu"};